import React, { useState } from 'react';
import moment from 'moment';
import { useFee } from '@debbie/cortex/dist/bespoke/apcoa/index.js';
import PlaceholderLoader from '../../PlaceholderLoader.js';
import Table from '../../Table.js';
import { AlertOctagon, ExternalLink } from '../../Icons/index.js';
import CopyToClipboard from '../../CopyToClipboard.js';
import { h } from '@debbie/cortex/dist/index.js';
import Badge from '../../Badge.js';
import THEME from '../../../theme.js';
import Alert from '../../Alert.js';
import Modal from '../../Modal.js';
import DMR from './DMR.js';
import { useSelector } from 'react-redux';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { PropertyDataType, } from '@debbie/common/dist/properties/index.js';
import { Entity } from '@debbie/common/dist/index.js';
import { useProperties } from '@debbie/cortex/dist/properties/index.js';
const getDuration = (fee) => {
    return moment.duration(moment(`2000-01-01 ${fee.observedTo}`).diff(moment(`2000-01-01 ${fee.observedFrom}`)));
};
const FeeCmp = (props) => {
    const { caseVoucher } = props;
    const singleCase = useSelector((s) => caseVoucher.caseId ? selectCaseById(s, caseVoucher.caseId) : null);
    const feeLoadable = useFee(caseVoucher.referenceId);
    const fee = h.isLoaded(feeLoadable) ? feeLoadable.data : null;
    const propertiesLoadable = useProperties(Entity.CaseVoucher, props.caseVoucher.caseVoucherId, 'case-group', singleCase?.caseGroup?.id);
    const properties = h.hasData(propertiesLoadable)
        ? propertiesLoadable.data
        : null;
    const [dmrOpen, setDmrOpen] = useState(false);
    const observedFromDate = properties?.find((property) => property.handle === 'observedfromdate' &&
        property.type === PropertyDataType.datePicker);
    const observedToDate = properties?.find((property) => property.handle === 'observedtodate' &&
        property.type === PropertyDataType.datePicker);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginRight: '-10px' } },
            h.isError(feeLoadable) && (React.createElement(Alert, { message: 'Dataen kunne ikke hentes fra Navision.', style: {
                    backgroundColor: THEME.DANGEROUS,
                }, size: "small" })),
            h.hasData(feeLoadable) && fee ? (React.createElement(React.Fragment, null,
                React.createElement(Table, { zebra: true },
                    React.createElement("tr", { style: { cursor: 'pointer' }, onClick: () => setDmrOpen(!dmrOpen) },
                        React.createElement("td", null, "Reg.nr."),
                        React.createElement("td", null,
                            React.createElement("small", null, fee.vehicleNationalityCode),
                            ' ',
                            React.createElement(CopyToClipboard, { text: fee.registrationNo },
                                React.createElement("b", null, fee.registrationNo)),
                            ' ',
                            React.createElement(ExternalLink, null))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Forseelse"),
                        React.createElement("td", null,
                            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, fee.warrant),
                            ' ',
                            fee.warrantDescription)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Udstedt af"),
                        React.createElement("td", null,
                            fee.issuedByName,
                            " (",
                            fee.issuedBy,
                            ")")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Udstedelsesdato"),
                        React.createElement("td", null, moment(fee.dateIssued).format(THEME.DATE_FORMAT_SHORT))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Bogf\u00F8ringsdato"),
                        React.createElement("td", null, moment(fee.postingDate).format(THEME.DATE_FORMAT_SHORT))),
                    fee.observedFrom &&
                        fee.observedTo &&
                        singleCase?.caseGroup?.id &&
                        // Kontrolgebyr case group
                        [
                            'f464faae-ee5b-4926-8fc2-03b51282dac4', // Apcoa
                            'aed1b922-f864-44af-a870-c7cf278e505e', // Euroincasso
                        ].includes(singleCase.caseGroup.id) && (React.createElement("tr", null,
                        React.createElement("td", null,
                            "Obstid start",
                            React.createElement("br", null),
                            "Obstid slut",
                            React.createElement("br", null),
                            "Obstid i alt"),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, null, fee.observedFrom),
                            React.createElement("br", null),
                            React.createElement(CopyToClipboard, null, fee.observedTo),
                            React.createElement("br", null),
                            moment
                                .utc(getDuration(fee).asMilliseconds())
                                .format('HH:mm'),
                            getDuration(fee).asMinutes() <
                                fee.parkingLotObsTimeMin && (React.createElement(Badge, { theme: THEME.DANGEROUS },
                                React.createElement(AlertOctagon, null),
                                " Advarsel"))))),
                    fee.observedFrom &&
                        fee.observedTo &&
                        singleCase?.caseGroup?.id &&
                        // ANPR case group
                        [
                            '1951db31-0885-4386-8a1e-fd78a34d7321', // Apcoa
                            '3b0970d0-b947-43f2-9e08-7385e3b7b3bc', // Euroincasso
                        ].includes(singleCase.caseGroup.id) && (React.createElement("tr", null,
                        React.createElement("td", null,
                            "Indk\u00F8rsel",
                            React.createElement("br", null),
                            "Udk\u00F8rsel"),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, null,
                                typeof observedFromDate?.data === 'string'
                                    ? moment(observedFromDate.data).format(THEME.DATE_FORMAT_SHORT)
                                    : null,
                                ' ',
                                "kl. ",
                                fee.observedFrom.slice(0, 5)),
                            React.createElement("br", null),
                            React.createElement(CopyToClipboard, null,
                                typeof observedToDate?.data === 'string'
                                    ? moment(observedToDate?.data).format(THEME.DATE_FORMAT_SHORT)
                                    : null,
                                ' ',
                                "kl. ",
                                fee.observedTo.slice(0, 5))))),
                    fee.parkingDiscShowed &&
                        singleCase?.caseGroup?.id &&
                        // Kontrolgebyr case group
                        [
                            'f464faae-ee5b-4926-8fc2-03b51282dac4', // Apcoa
                            'aed1b922-f864-44af-a870-c7cf278e505e', // Euroincasso
                        ].includes(singleCase.caseGroup.id) && (React.createElement("tr", null,
                        React.createElement("td", null, "P-skive viste"),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, null, fee.parkingDiscShowed.slice(0, 5))))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "APCOA Maps"),
                        React.createElement("td", null,
                            React.createElement("a", { target: "_blank", href: `https://mapinfo.apcoa.dk/smart/profile/baa26c87-6972-42ee-b7ed-1944683959d6/d80e44c9-19a8-4195-84e4-7b49abb54dd2/89dbad69-5199-4533-ad64-161a0c5bf64b?language=da#?supervisionfeenumber=${caseVoucher.referenceId}` },
                                "Se kort",
                                ' ',
                                React.createElement(ExternalLink, { style: { margin: '0.2em 0 -0.2em 0' } })))),
                    fee.internalComments && (React.createElement("tr", null,
                        React.createElement("td", null, "Intern kommentar"),
                        React.createElement("td", null, fee.internalComments ? fee.internalComments : '-')))))) : (!h.isError(feeLoadable) && (React.createElement(React.Fragment, null,
                React.createElement(PlaceholderLoader, { width: "200px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "120px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "140px" }))))),
        dmrOpen && (React.createElement(Modal, { maxWidth: "600px", header: 'DMR', onToggle: () => setDmrOpen(!dmrOpen) },
            React.createElement(DMR, { caseVoucher: caseVoucher })))));
};
export default FeeCmp;
//# sourceMappingURL=Fee.js.map